<template>
  <div>
    <dara-header size="md">Oops!</dara-header>
    <dara-header>{{ $t('something-went-wrong') }}</dara-header>
    <dara-p>{{ $t('please-try-to-reload-page-or-contact-support') }}</dara-p>
    <dara-button class="btn btn-primary" @click="goToBasePage()">
      {{ $t('return-to-page') }}
    </dara-button>
  </div>
</template>

<script>
import { goToBasePage } from '@/router/route.service';

export default {
  name: 'DaraGenericErrorPage',
  methods: {
    goToBasePage,
  },
};
</script>
